import clsx$1 from 'clsx';
import _Object$defineProperty$1 from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _Object$defineProperties$1 from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$getOwnPropertyDescriptors$1 from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _forEachInstanceProperty$1 from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptor$1 from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _filterInstanceProperty$1 from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertySymbols$1 from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$keys$1 from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _defineProperty$1 from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import size$1 from '../../mixins/size.mjs';
import space$1 from '../../mixins/space.mjs';
import modifier$1 from '../../mixins/modifier.mjs';
import _indexOfInstanceProperty$1 from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import fullWidth$1 from '../../mixins/fullWidth.mjs';
import style from './styles/CdrButton.mjs';

function ownKeys(object, enumerableOnly) { var keys = _Object$keys$1(object); if (_Object$getOwnPropertySymbols$1) { var symbols = _Object$getOwnPropertySymbols$1(object); if (enumerableOnly) symbols = _filterInstanceProperty$1(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor$1(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; _forEachInstanceProperty$1(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { _defineProperty$1(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors$1) { _Object$defineProperties$1(target, _Object$getOwnPropertyDescriptors$1(source)); } else { var _context4; _forEachInstanceProperty$1(_context4 = ownKeys(Object(source))).call(_context4, function (key) { _Object$defineProperty$1(target, key, _Object$getOwnPropertyDescriptor$1(source, key)); }); } } return target; }
var CdrButton = {
  name: 'CdrButton',
  mixins: [modifier$1, size$1, space$1, fullWidth$1],
  props: {
    /**
     * Controls render as button or anchor. {button, a}
     */
    tag: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        var _context;

        return _indexOfInstanceProperty$1(_context = ['button', 'a']).call(_context, value) >= 0 || false;
      }
    },

    /**
     * Sets the button type. {button, submit, reset}
     */
    type: {
      type: String,
      default: 'button',
      validator: function validator(value) {
        var _context2;

        return _indexOfInstanceProperty$1(_context2 = ['button', 'submit', 'reset']).call(_context2, value) >= 0 || false;
      }
    },

    /**
     * Renders an icon-only button. Default slot is disabled. Overrides size and responsiveSize props.
     */
    iconOnly: {
      type: Boolean,
      default: false
    },

    /**
     * Used in conjunction with `icon-only`, renders a border and background around the icon button
     */
    withBackground: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    baseClass() {
      return 'cdr-button';
    },

    defaultClass() {
      return this.modifyClassName(this.baseClass, 'primary');
    },

    buttonSizeClass() {
      return !this.iconOnly ? this.sizeClass : null;
    },

    iconClass() {
      var classes = [];

      if (this.$slots.icon && this.$slots.default) {
        /* only add class for buttons with text + icon */
        classes.push(this.modifyClassName(this.baseClass, 'has-icon'));
      }

      if (this.iconOnly) {
        classes.push(this.modifyClassName(this.baseClass, 'icon-only'));
      }

      if (this.iconOnly && this.withBackground) {
        classes.push(this.modifyClassName(this.baseClass, 'with-background'));
      }

      return classes.join(' ');
    }

  },

  render() {
    var h = arguments[0];
    var Component = this.tag;
    return h(Component, {
      "class": clsx$1(this.defaultClass, this.style[this.baseClass], this.modifierClass, this.buttonSizeClass, this.fullWidthClass, this.iconClass, this.space),
      "attrs": {
        "type": this.tag === 'button' ? this.type : null
      },
      "on": _objectSpread({}, this.$listeners)
    }, [this.$slots.icon, this.$slots.default]);
  }

};

export default CdrButton;
